export default __webpack_public_path__ + "static/media/dataPreviewShow.bcc93519.svg";